import { Moment } from 'moment';
import { IBook } from './book.model';
import { IUser } from './user.model';

export interface IBookSubscription {
  id?: number;
  isActive?: boolean;
  subscriptionStartDate?: Moment;
  subscriptionEndDate?: Moment;
  createdDate?: Moment;
  lastModifiedDate?: Moment;
  book?: IBook;
  createdBy?: IUser;
  lastModifiedBy?: IUser;
  user?: IUser;
}

export const defaultValue: Readonly<IBookSubscription> = {
  isActive: false
};
